import React, { useState } from 'react';
import { useRouter } from 'next/router';
import CbtRoundTableHeader from 'app.feature/academy/cbt.detail/component/CbtRoundTableHeader';
import CbtRoundTableFooter from 'app.feature/academy/cbt.detail/component/CbtDetailMoreButton';
import { convertExamDetailQueryString } from 'app.feature/academy/cbt.detail/module/convertExamDetailQueryString';
import { useRecoilValue } from 'recoil';
import { projectConfigState } from 'recoil/Academy/projectConfigState';
import { useCurrentUser } from 'src/app.hooks/useCurrentUser';
import CbtRoundTableMobile from 'app.feature/academy/cbt.detail/component/CbtRoundTableMobile';
import CbtRoundTablePc from 'app.feature/academy/cbt.detail/component/CbtRoundTablePc';
import { TExamsInfo } from 'app.type/examsInfo';
import { TExamsDetails } from 'app.type/examsDetails';
import { useQuery } from '@tanstack/react-query';
import ExamApi from 'lib/api/exam';

const CbtRoundTable = () => {
  const router = useRouter();
  const examIdx = Number(router.query.examIdx);
  const [showAll, setShowAll] = useState(false);
  const { handleLoginRedirect } = useRecoilValue(projectConfigState);
  const { user } = useCurrentUser();

  const { data: examInfo = null } = useQuery<TExamsInfo>({
    queryKey: [`/apiV2/exams/${examIdx}`],
    queryFn: () => ExamApi.getExamInfo(examIdx),
  });

  const examTitle = examInfo?.examName;

  const { data: examDetail = [] } = useQuery<TExamsDetails[]>({
    queryKey: [
      `/apiV2/exams/${examIdx}/exam-details`,
      convertExamDetailQueryString({ sorts: router.query.sorts }),
    ],
    queryFn: () =>
      ExamApi.getExamDetails(examIdx, convertExamDetailQueryString({ sorts: router.query.sorts })),
  });

  const displayedExams = showAll ? examDetail : examDetail?.slice(0, 11);
  const handleShowMore = () => {
    setShowAll(true);
  };

  const handleSolveButtonClick = (examDetailIdx: number) => {
    if (!user) {
      router.push(handleLoginRedirect(window.location.href));
      return;
    }
    router.push(`/cbt/select/${examDetailIdx}`);
  };

  return (
    <>
      <CbtRoundTableHeader examDetail={examDetail} />
      <CbtRoundTablePc
        examInfo={examInfo}
        examDetail={examDetail}
        displayedExams={displayedExams}
        handleSolveButtonClick={handleSolveButtonClick}
      />
      <CbtRoundTableMobile
        examTitle={examTitle}
        examDetail={examDetail}
        handleSolveButtonClick={handleSolveButtonClick}
      />
      {!showAll && examDetail.length > 11 && (
        <CbtRoundTableFooter handleShowMore={handleShowMore} arrow={'down'} />
      )}
    </>
  );
};

export default CbtRoundTable;
